import { useCallback } from 'react';
import type React from 'react';

import { LazyComponent } from 'src/app/shared/components/layout/lazy';

import type { Props } from './RichTextEditor';

export const RichTextEditorWrapper: React.FC<Props> = (props) => {
	const loadComponent = useCallback(
		async () => (await import(/* webpackChunkName: "cmp/rich_text_editor" */ './RichTextEditor')).RichTextEditor,
		[],
	);

	return <LazyComponent loadComponent={loadComponent} {...props} />;
};
